function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".a{fill:#fff;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("path", {
  className: "a",
  d: "M15.041,13.075A3.623,3.623,0,0,0,13.694,7.63V4.444L9.25,0H.168V17.667H13.694v-3.49a3.594,3.594,0,0,0,.615-.37l2.778,2.809.736-.728ZM9.553,1.767l2.373,2.373H9.553Zm3.105,14.864H1.2V1.035H8.518V5.176h4.141V7.319a3.622,3.622,0,1,0,0,7.169Zm1.312-3.9a2.588,2.588,0,1,1,0-3.66A2.591,2.591,0,0,1,13.971,12.733Z",
  transform: "translate(-0.168)"
}), React.createElement("g", {
  transform: "translate(2.07 6.245)"
}, React.createElement("rect", {
  className: "a",
  width: 7.315,
  height: 1.035
})), React.createElement("g", {
  transform: "translate(2.07 8.316)"
}, React.createElement("rect", {
  className: "a",
  width: 5.245,
  height: 1.035
})), React.createElement("g", {
  transform: "translate(2.07 12.456)"
}, React.createElement("rect", {
  className: "a",
  width: 5.245,
  height: 1.035
})), React.createElement("g", {
  transform: "translate(2.07 10.386)"
}, React.createElement("rect", {
  className: "a",
  width: 5.245,
  height: 1.035
})));
var SvgPreviewFile = function SvgPreviewFile(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 17.654,
    height: 17.667,
    viewBox: "0 0 17.654 17.667",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPreviewFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PreviewFile.ee1aa0da.svg";
export { ForwardRef as ReactComponent };